<template>
  <div>
    <TermlyModal v-model="showTCModal" termlyId="beb56943-acef-4d52-a264-4f6dc3cb4590" />
    <TermlyModal v-model="showPPModal" termlyId="b9051d81-f909-45d2-b64f-3b4531bee4f7" />
    <TermlyModal v-model="showCPModal" termlyId="afc3d28b-653b-4d76-b9db-7d0b324d6189" />
    <TermlyModal
      v-model="showEULAModal"
      termlyId="8d2b88a5-6fa6-45fe-becc-cfc7ab123c72"
    />
    <TermlyModal v-model="showAPModal" termlyId="e84211d3-81e5-40d0-8d25-c96f913f7b5e" />
  </div>
</template>

<script>
import Vue from "vue";
import { defineComponent, ref } from "@vue/composition-api";

import TermlyModal from "./TermlyModal.vue";

export default defineComponent({
  name: "TermlyWrapper",
  components: {
    TermlyModal,
  },
  setup() {
    const showTCModal = ref(false);
    const showPPModal = ref(false);
    const showCPModal = ref(false);
    const showEULAModal = ref(false);
    const showAPModal = ref(false);

    Vue.prototype.$emitter.on("toggle-termly-modal", (modal) => {
      if ("terms-and-conditions" === modal) showTCModal.value = true;
      else if ("privacy-policy" === modal) showPPModal.value = true;
      else if ("cookie-policy" === modal) showCPModal.value = true;
      else if ("eula" === modal) showEULAModal.value = true;
      else if ("acceptable-use-policy" === modal) showAPModal.value = true;
    });

    return {
      showTCModal,
      showPPModal,
      showCPModal,
      showEULAModal,
      showAPModal,
    };
  },
});
</script>
